<template>
  <v-form ref="formReservation" v-model="validForm" lazy-validation>
    <v-text-field :rules="[rules.required]" v-model="title" label="Titulo"></v-text-field>
    <v-text-field :rules="[rules.required]" v-model="description" label="Descripción"></v-text-field>
    <v-row>
      <v-col sm="6">
        <v-text-field  v-model="book.customer.name" label="Socio" readonly disable></v-text-field>       
      </v-col>
      <v-col sm="6">
        <v-text-field  v-model="book.room.title" label="Amenidad Reservada" readonly disable></v-text-field>   
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6">
        <v-text-field  v-model="formattedReservationDate" label="Fecha de Reservacion" readonly disable></v-text-field>               
      </v-col>
      <v-col sm="6">
        <v-text-field  v-model="formattedReservationHour" label="Hora de Reservacion" readonly disable></v-text-field>        
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6">
        <v-text-field  v-model="formattedLapse" label="Duración" readonly disable></v-text-field> 
      </v-col>
      <v-col sm="6">
      </v-col>
    </v-row>
    <v-btn @click="save" depressed color="#00aff2" dark>Guardar</v-btn>
  </v-form>
</template>

<script>
import adminReservationsService from '@/services/admin/reservations';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);
dayjs.locale('es');

export default {
  
  props: {
    book: {
      type: Object,
      required: true,
    },
  }, 
  data() {
    return {
      validForm: true,
      rules: {       
        required: (value) => !!value || 'Required.',
      },
      
      title: this.book.title,
      description: this.book.description,
      customerId: this.book.customerId,
      
      
    };
  },  
  computed: {
    formattedReservationDate() {
        const date = new Date(this.book.reservationDate + 'T00:00:00');
        const parts = new Intl.DateTimeFormat('es-ES', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        }).format(date).split(' de ');

        parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
        return `${parts[0]} ${parts[1]} ${parts[2]}`;
        },
    formattedReservationHour() {
      return this.book?.reservationHour ? `${this.book.reservationHour} hrs` : '';
    },
    formattedLapse(){
      return this.book?.reservationHour ? `${this.book.lapse} horas` : '';
    }
  },
  methods: {   
    save() {
      if (this.$refs.formReservation.validate()) {
        const data = {
          id: this.book.id, 
          title: this.title,
          description: this.description,              
        };
        adminReservationsService
          .update(data)
          .then((response) => {
           // this.$refs.formReservation.reset();  borraba los datos de la forma 
           
            this.$emit('on-save', response.data);
            this.$swal('Reservación', 'La reservación ha sido actualizada correctamente.', 'success');
          })
          .catch((error) => {
            if (error.response && [400, 409].includes(error.response.status)) {
              this.$swal('Error al actualizar reservación', error.response.data.message, 'warning');
            }
          });
      }
    },   
  },
};
</script>